<template>
  <div :class="isList ? 'articleList' : 'articlePage'">
    <ul v-if="limit === undefined">
      <li v-for="(item, index) in artList" :key="item.Code">
        <ArticleInfo :article-info="item" />
      </li>
    </ul>
    <ul v-else>
      <li v-for="(item, index) in artList" :key="item.Code">
        <ArticleInfo v-if="index < limit" :article-info="item" />
      </li>
    </ul>
    <div v-if="isClickMore && !noMorePage && !isLoading" class="articleMore-button">
      <a @click.prevent="onClickMore">閱讀更多</a>
    </div>
    <div v-if="isLoading" class="articleMore-loading">
      <img src="https://pic.pzcdn.tw/design/index/2020banner/loding.png" alt="loading" />
    </div>
  </div>
</template>

<script setup>
import $ from 'jquery';
import { ref } from 'vue';

import ArticleInfo from '@page/article/components/parts/ArticleInfo.vue';

import useAxiosAPI from '@global/composable/api/useAxiosAPI';

const { getArticleListAPI } = useAxiosAPI();

const artList = ref('');
const page = ref(1);
const noMorePage = ref(false);
const isLoading = ref(false);
const pageTotal = ref(1);

const props = defineProps({
  categoryName: {
    type: String,
    required: true,
  },
  isList: {
    type: Boolean,
    required: true,
  },
  isClickMore: {
    type: Boolean,
    required: true,
  },
  limit: {
    type: Number,
    default: 10,
  },
  hasLimit: {
    type: Boolean,
    default: false,
  },
});

function getList() {
  getArticleListAPI({
    params: { Category: props.categoryName, Limit: props.limit, Page: 1 },
  })
    .then((res) => {
      if (res.data.Code === 200) {
        artList.value = res.data.Response.Data;
        pageTotal.value = res.data.Response.PageCount;
        if (res.data.Response.Page < res.data.Response.PageCount) $('.articleMore-button').fadeIn();
      }
    })
    .catch((error) => {
      console.log(error);
    });
}

getList();

function loadArticle(loadPage) {
  const isMorePage = pageTotal.value >= loadPage;
  noMorePage.value = pageTotal.value === loadPage;

  if (isMorePage) {
    getArticleListAPI({
      params: { Category: props.categoryName, Limit: props.limit, Page: loadPage },
    })
      .then((res) => {
        if (res.data.Code === 200) {
          artList.value = artList.value.concat(res.data.Response.Data);
          page.value = loadPage;
          pageTotal.value = res.data.Response.PageCount;
          if (res.data.Response.Page < res.data.Response.PageCount) {
            $('.articleMore-button').fadeIn();
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  } else {
    $('.articleMore-button').fadeIn();
  }
}

function onLoadMore() {
  setTimeout(() => {
    loadArticle(page.value + 1);
    isLoading.value = false;
  }, Math.random() * 750 + 250);
}

function onClickMore(e) {
  e.preventDefault();
  isLoading.value = true;
  onLoadMore();
}
</script>
